import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { Spin } from "antd";
import "./pdf.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PropertyPhTenPdf from "./PropertyPhTenPdf";
import { bindActionCreators } from "redux";
import * as taxCollectionActions from "../../../../../actionCreators/TaxCollection";
import PropertyPhTenBacksidePdf from "./PropertyPhTenBacksidePdf";

const PhTenForm = ({ PH10s, createPH10 }) => {
  const { id } = useParams();
  const value = useRef(null);
  const backsideValue = useRef(null);
  const history = useHistory();
  const [newDataLoaded, setNewDataLoaded] = useState(false);
  React.useEffect(() => {
    createPH10([{ id: id }]);
  }, [id]);
  useEffect(() => {
    if (PH10s.data != null && newDataLoaded) {
      let input = value.current;
      const pdf = new jsPDF();
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        let imgWidth = 250;
        let imgHeight = 180;
        let position = 100;
        let positionY = 200;
        pdf.addImage(imgData, "JPEG", positionY, position, imgWidth, imgHeight, null, null, 90);
        pdf.addPage();
        input = backsideValue.current;
        html2canvas(input).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          let imgWidth = 200;
          let imgHeight = 180;
          let position = 110;
          let positionY = 185;
          pdf.addImage(imgData, "JPEG", positionY, position, imgWidth, imgHeight, null, null, 90);
          pdf.save("download1.pdf");
          window.open(pdf.output("bloburl"), "_blank");
        });
      });
    }
    setNewDataLoaded(true);
  }, [PH10s]);

  if (PH10s.data != null) {
    return (
      <>
        <div className="close-button-section">
          <Button
            className="close-button"
            // type="primary"
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowLeftOutlined />
            <span>Back</span>
          </Button>
        </div>
        <div
          id="Artboard__2"
          ref={value}
          style={
            {
              // transform: 'rotate(90deg)',
              // marginTop: "18vw",
              // marginBottom: "18vw",
              // marginLeft: "18vw",
              // position: 'absolute',
              // top: 600,
            }
          }
        >
          <PropertyPhTenPdf data={PH10s.data[0]} />
        </div>
        <div
          id="Artboard__2"
          ref={backsideValue}
          style={
            {
              // transform: 'rotate(270deg)',
              marginTop: "150%",
              // marginBottom: "18vw",
              marginLeft: "5%",
              // position: 'absolute',
              // top: 600,
            }
          }
        >
          <PropertyPhTenBacksidePdf data={PH10s.data[0]} />
        </div>
      </>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin />
      </div>
    );
  }
};

const mapStateToProps = ({ taxCollection: { PH10s } }) => ({
  PH10s,
});

const mapDispatchToProps = (dispatch) => ({
  createPH10: bindActionCreators(taxCollectionActions.createPH10, dispatch),
});

PhTenForm.propTypes = {
  PH10s: PropTypes.object.isRequired,
  createPH10: PropTypes.func.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(PhTenForm);
